import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getImageUrl } from '../../../configs/configs';
import { Button } from 'react-bootstrap';
import { showModal, hideModal } from '../../../actions/modalsActions'
import { updateItem } from '../../../actions/relationActions';
import CyberSecurity from '../../../apis/cyberSecurityData';
import _ from 'lodash';

//imported components
import ItemToChoose from './ItemToChoose';
import ListOfExistRelations from './ListOfExistRelations';
import FilterOptions from './FilterOptions';
import SelectedItem from './SelectedItem';

const AddExistingRelations = (props) => {
    //creating a hook to include the items to be shown, and initialize it with the items from the redux store.
    const [items, setItems] = useState([]); //fetched items to choose from
    const [item, setItem] = useState(props.item); //the current item to add relations to
    const [page, setPage] = useState(1);

    const [search, setSearch] = useState('');
    const [searchText, setSearchText] = useState('');
    const [exactMatch, setExactMatch] = useState(true);

    const [mainCategory, setMainCategory] = useState('Threats');
    const [subCategory, setSubCategory] = useState('');
    const [industry, setIndustry] = useState('');

    const [selectedBreaches, setSelectedBreaches] = useState({});
    const [selectedStories, setSelectedStories] = useState({});
    const [selectedThreats, setSelectedThreats] = useState({});
    const [selectedActors, setSelectedActors] = useState({});
    const [selectedSolutions, setSelectedSolutions] = useState({});
    const [selectedCompanies, setSelectedCompanies] = useState({});
    const [selectedExperts, setSelectedExperts] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);

    const onAddClick = (item) => {
        if (item.mainCategory === 'Stories' && item.newTag5 && item.newTag5.toLowerCase().includes('breach')) setSelectedBreaches({ ...selectedBreaches, [item._id]: item })
        else if (item.mainCategory === 'Stories') setSelectedStories({ ...selectedStories, [item._id]: item })
        if (item.mainCategory === 'Threats') setSelectedThreats({ ...selectedThreats, [item._id]: item })
        if (item.mainCategory === 'Actors') setSelectedActors({ ...selectedActors, [item._id]: item })
        if (item.mainCategory === 'Solutions') setSelectedSolutions({ ...selectedSolutions, [item._id]: item })
        if (item.mainCategory === 'Companies') setSelectedCompanies({ ...selectedCompanies, [item._id]: item })
        if (item.mainCategory === 'Experts') setSelectedExperts({ ...selectedExperts, [item._id]: item })
        setSelectedIds(selectedIds => [...selectedIds, item._id]);
    }

    const onRemoveClick = ({ mainCategory, _id }) => {
        if (mainCategory === 'Stories' && item.newTag5 && item.newTag5.toLowerCase().includes('breach')) setSelectedBreaches(_.omit(selectedBreaches, _id))
        else if (mainCategory === 'Stories') setSelectedStories(_.omit(selectedStories, _id))
        if (mainCategory === 'Threats') setSelectedThreats(_.omit(selectedThreats, _id))
        if (mainCategory === 'Actors') setSelectedActors(_.omit(selectedActors, _id))
        if (mainCategory === 'Solutions') setSelectedSolutions(_.omit(selectedSolutions, _id))
        if (mainCategory === 'Companies') setSelectedCompanies(_.omit(selectedCompanies, _id))
        if (mainCategory === 'Experts') setSelectedExperts(_.omit(selectedExperts, _id))
        setSelectedIds(selectedIds.filter(el => el !== _id));
    }

    const renderItemsToChoose = () => {
        return items.map(el => {
            if (selectedIds.includes(el._id)) return <ItemToChoose item={el} onAddClick={onAddClick} onRemoveClick={onRemoveClick} selected={true} key={el._id} />
            else return <ItemToChoose item={el} onAddClick={onAddClick} onRemoveClick={onRemoveClick} selected={false} key={el._id} />
        })
    }

    const setSeachTerm = (term) => {
        setSearch(term)
    }

    const onSearchSubmit = () => {
        if (search) setSearchText(search);
    }

    const mainCategoryCallback = (value) => setMainCategory(value); // callback function to set the main category from the FilterOptions Component
    const subCategoryCallback = (value) => setSubCategory(value); // callback function to set the Sub category from the FilterOptions Component
    const industryCallback = (value) => setIndustry(value); // callback function to set the industry from the FilterOptions Component
    const clearCallback = () => {
        setSubCategory('');
        setIndustry('')
        setSearchText('')
        setPage(1);
    }
    const exactMatchcallBack = (value) => setExactMatch(value)

    const fetchData = async () => {
        setPage(1);
        const response = await CyberSecurity.post('/getdata', { searchText, mainCategory, subCategory, industry, exactMatch, page }, {
            headers: {
                Authorization: 'Bearer ' + props.accessToken
            }
        })
        setItems(response.data)
    }

    const onShowMoreClick = async () => {
        const response = await CyberSecurity.post('/getdata', { searchText, mainCategory, subCategory, industry, exactMatch, page: (page + 1) }, {
            headers: {
                Authorization: 'Bearer ' + props.accessToken
            }
        })
        setPage((page + 1))
        let data = items.concat(response.data)
        setItems(data)
    }

    useEffect(() => {
        fetchData();
    }, [searchText, mainCategory, subCategory, industry, exactMatch])

    const onAddSelectedClick = async () => {
        const Breaches = Object.values(selectedBreaches).map(el => el._id);
        const Stories = Object.values(selectedStories).map(el => el._id);
        const Threats = Object.values(selectedThreats).map(el => el._id);
        const Actors = Object.values(selectedActors).map(el => el._id);
        const Solutions = Object.values(selectedSolutions).map(el => el._id);
        const Companies = Object.values(selectedCompanies).map(el => el._id);
        const Experts = Object.values(selectedExperts).map(el => el._id);

        const itemData = {
            _id: item._id,
            mainCategory: item.mainCategory,
            newTag5: item.newTag5,
        }
        const requestBody = { Breaches, Stories, Threats, Actors, Solutions, Companies, Experts, selectedIds, item: itemData };
        const response = await CyberSecurity.post('/addrelations', requestBody, {
            headers: {
                Authorization: `Bearer ${props.accessToken}`
            }
        })

        //action to update the ui from the item
        props.updateItem(response.data);

        //action to hide the Modal after adding all relations
        props.hideModal();
    }

    return (
        <div className="box-area d-flex justify-content-center">
            <div className="current-relations card">
                <div className='section-title'>
                    <p>Current Relations</p>
                </div>
                <div className="p-2">
                    <ListOfExistRelations item={props.item} />
                </div>
            </div>

            <div className="choose-relations mx-3">

                {/* The Item that the relations will be added to */}
                <div className='main-item d-flex p-3 mb-3'>
                    <div>
                        <p className='tileTop'>{item.tileTop}</p>
                        <p className='tile'>{item.title}</p>
                    </div>
                    <img className='item-image' src={getImageUrl(item.image)} />
                </div>

                {/* Filtering component */}
                <FilterOptions
                    setSeachTerm={setSeachTerm}
                    onSearchSubmit={onSearchSubmit}
                    mainCategoryCallback={mainCategoryCallback}
                    subCategoryCallback={subCategoryCallback}
                    industryCallback={industryCallback}
                    clearCallback={clearCallback}
                    exactMatchcallBack={exactMatchcallBack}
                />

                {/* The items to choose from */}
                <div className='container'>
                    <div className="row justify-content-center">
                        {renderItemsToChoose()}
                    </div>
                    <div className="row justify-content-center">
                        <div className="d-flex mt-3">
                            <Button variant="outline-secondary mr-2" size="sm" onClick={() => props.hideModal()}>Cancel</Button>
                            <Button variant="primary" size="sm" onClick={onAddSelectedClick}
                                disabled={selectedIds.length > 0 ? false : true}
                            >Add Selected</Button>
                            <Button variant="outline-secondary ml-2" size="sm" onClick={onShowMoreClick}>Load More</Button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="selected-relations card">
                <div className='section-title'>
                    <p>Selected Items</p>
                </div>
                <div className="p-2">
                    {Object.values(selectedBreaches).length > 0 ? <p className="exist-relation-title info-Breaches">Selected Breaches</p> : null}
                    {Object.values(selectedBreaches).map(el => <SelectedItem item={el} onRemoveClick={onRemoveClick} key={el._id} />)}

                    {Object.values(selectedStories).length > 0 ? <p className="exist-relation-title info-Stories">Selected Stories</p> : null}
                    {Object.values(selectedStories).map(el => <SelectedItem item={el} onRemoveClick={onRemoveClick} key={el._id} />)}

                    {Object.values(selectedThreats).length > 0 ? <p className="exist-relation-title info-Threats">Selected Threats</p> : null}
                    {Object.values(selectedThreats).map(el => <SelectedItem item={el} onRemoveClick={onRemoveClick} key={el._id} />)}

                    {Object.values(selectedActors).length > 0 ? <p className="exist-relation-title info-Actors">Selected Actors</p> : null}
                    {Object.values(selectedActors).map(el => <SelectedItem item={el} onRemoveClick={onRemoveClick} key={el._id} />)}

                    {Object.values(selectedSolutions).length > 0 ? <p className="exist-relation-title info-Solutions">Selected Solutions</p> : null}
                    {Object.values(selectedSolutions).map(el => <SelectedItem item={el} onRemoveClick={onRemoveClick} key={el._id} />)}

                    {Object.values(selectedCompanies).length > 0 ? <p className="exist-relation-title info-Companies">Selected Companies</p> : null}
                    {Object.values(selectedCompanies).map(el => <SelectedItem item={el} onRemoveClick={onRemoveClick} key={el._id} />)}

                    {Object.values(selectedExperts).length > 0 ? <p className="exist-relation-title info-Experts">Selected Experts</p> : null}
                    {Object.values(selectedExperts).map(el => <SelectedItem item={el} onRemoveClick={onRemoveClick} key={el._id} />)}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { items: Object.values(state.items), accessToken: state.accessToken }
}

export default connect(mapStateToProps, { showModal, hideModal, updateItem })(AddExistingRelations)
